
















































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import rules from "../../utils/rules";
import { Translate } from "../../services/language/entities/translate.interface";
import constants from "../../config/constants";

@Component
export default class UpdateServiceDialog extends Vue {
  @Prop() dialogUpdate!: boolean;
  @Prop() service!: any;
  @Prop() page!: number;

  image = "";
  newImage = "";
  file = "";
  photoRules = [rules.files];
  newPhotoRules = [rules.files, rules.notFiles];
  generalRules = [rules.notEmpty];
  name: Array<Translate> = [];
  description: Array<Translate> = [];

  $refs!: {
    formUpdate: HTMLFormElement;
  };

  valid = true;
  loadingUpdate = false;
  snackbarSuccessUpdate = false;
  snackbarErrorUpdate = false;

  private created(): void {
    this.image = this.service.servicePhotoURL;
    this.service.serviceNameTranslate.forEach((translate: Translate) => {
      this.name.push({
        languageName: translate.languageName,
        iso: translate.iso,
        text: translate.text
      });
    });

    this.service.serviceDescriptionTranslate.forEach((translate: Translate) => {
      this.description.push({
        languageName: translate.languageName,
        iso: translate.iso,
        text: translate.text
      });
    });
  }

  private previewImage(event: any): void {
    if (event) {
      const file = event || event.dataTransfer.files;
      this.file = file;
      this.createImg(file);
    } else {
      this.file = "";
      this.newImage = "";
    }
  }

  private createImg(file: any): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.newImage = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  private cancelUpdate(): void {
    this.$emit("cancelUpdate");
  }

  private updateService(): void {
    const nameTranslate = this.name.map((translate: Translate) => {
      return { iso: translate.iso, text: translate.text };
    });
    const descriptionTranslate = this.description.map(
      (translate: Translate) => {
        return { iso: translate.iso, text: translate.text };
      }
    );
    this.loadingUpdate = true;
    this.$store
      .dispatch("service/updateService", {
        serviceId: this.service.serviceID,
        terms: [
          {
            name: this.service.serviceNameTerm,
            translate: nameTranslate
          },
          {
            name: this.service.serviceDescriptionTerm,
            translate: descriptionTranslate
          }
        ],
        photoUrl: this.file !== `` ? this.file : this.image,
        status: this.service.serviceStatus,
        currentPhoto: this.image,
        newPhoto: this.newImage !== `` ? true : false,
        start: this.page * constants.ITEMS_PER_PAGE - constants.ITEMS_PER_PAGE,
        quantity: constants.ITEMS_PER_PAGE
      })
      .then((response: boolean) => {
        if (response) {
          this.snackbarSuccessUpdate = true;
        } else {
          this.snackbarErrorUpdate = true;
        }

        this.loadingUpdate = false;
        this.$emit("cancelUpdate");
      });
  }

  private get allStatus(): Array<string> {
    return this.$store.getters["common/getStatus"];
  }
}
